import { createHtmlElement, ElementStyle } from './create-html-element';

export const createInfoElement = () => {
  const infoElementStyles: ElementStyle[] = [
    { property: 'font-size', value: '14px' },
    { property: 'text-align', value: 'center' },
    { property: 'max-width', value: '350px' },
  ];
  const infoElement = createHtmlElement('div', infoElementStyles);

  const messageElementStyles: ElementStyle[] = [
    { property: 'font-size', value: '15px' },
    { property: 'line-height', value: '1.5' },
    { property: 'padding', value: '0 0 40px 0' },
  ];
  const messageElement = createHtmlElement('div', messageElementStyles);
  messageElement.innerText =
    'Don’t see the 3D secure browser? We’ll help you re-launch the window to complete your purchase';

  const continueElementStyles: ElementStyle[] = [
    { property: 'font-size', value: '15px' },
    { property: 'font-weight', value: '700' },
    { property: 'color', value: '#fff' },
    { property: 'text-decoration', value: 'none' },
    { property: 'border-bottom', value: '1px solid #fff' },
  ];

  const continueElement = createHtmlElement('a', continueElementStyles);
  continueElement.innerText = 'Click to Continue';

  infoElement.appendChild(messageElement);
  infoElement.appendChild(continueElement);
  return infoElement;
};
